import { Activity, ActivityType } from 'app/shared/features/activity-selector/models';
import { isLocationTypeAndResultDeterminationTypeSupported } from 'app/shared/features/activity-selector/utils';
import { LocationType } from 'app/shared/features/location-selector/models';
import { ResultDeterminationType } from 'app/shared/models';
import { MeasurementType } from 'app/shared/models/measurement-type';

export function isActivitySupportedForScanFlow(a: Activity) {
    return (
        [
            ActivityType.Break,
            ActivityType.Harvest,
            ActivityType.Generic,
            ActivityType.CropMaintenance,
            ActivityType.Packing,
        ].includes(a.activityType) && isLocationTypeAndResultDeterminationTypeSupported(a)
    );
}

export function isBatchRequired(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.isBatchInputRequired;
}

// All location types except Row and null are supported for single location selection only
export function isSingleLocationRequired(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.locationType !== LocationType.Row && !isLocationTypeNullOrSite(activity);
}

export function isOneOrManyLocationRequired(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.locationType === LocationType.Row;
}
export function isLocationTypeNullOrSite(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.locationType === LocationType.Site || activity.locationType === null;
}
export function isSingleContainerRequired(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.resultDeterminationType === ResultDeterminationType.byOneContainer;
}

export function isSingleAmountResultRequired(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.resultDeterminationType === ResultDeterminationType.byAmount;
}

export function isOneOrManyContainersRequired(activity: Activity | undefined) {
    if (!activity) return false;
    return [ResultDeterminationType.byContainer, ResultDeterminationType.ByContainerAndProductBox].includes(
        activity.resultDeterminationType,
    );
}

export function isOneOrManyProductBoxRegistrationsRequired(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.resultDeterminationType === ResultDeterminationType.byAmountAndProductBox;
}

export function isOneOrManyProductBoxRequired(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.resultDeterminationType === ResultDeterminationType.ByContainerAndProductBox;
}

export function isContainerMeasurementWeight(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.measurementType === MeasurementType.containerWeight;
}

export function isContainerMeasurementProductBoxes(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.measurementType === MeasurementType.containerProductBoxes;
}

export function isPackingActivity(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.activityType === ActivityType.Packing;
}

export function isActivityMatchLocationType(
    currentActivity: Activity | undefined,
    scannedCodeLocationType: LocationType | null,
) {
    return currentActivity?.locationType === scannedCodeLocationType;
}
